import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterSidebar = ({ filters, onFilterChange, onClearFilters, onSavePreset }) => {
  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'spare', label: 'Spare' },
    { value: 'repair', label: 'Repair' },
    { value: 'retired', label: 'Retired' }
  ];

  const typeOptions = [
    { value: '', label: 'All Types' },
    { value: 'laptop', label: 'Laptop' },
    { value: 'desktop', label: 'Desktop' },
    { value: 'server', label: 'Server' },
    { value: 'printer', label: 'Printer' },
    { value: 'monitor', label: 'Monitor' },
    { value: 'tablet', label: 'Tablet' },
    { value: 'phone', label: 'Phone' }
  ];

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'IT', label: 'Information Technology' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'Finance', label: 'Finance' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Sales', label: 'Sales' },
    { value: 'Operations', label: 'Operations' },
    { value: 'Legal', label: 'Legal' }
  ];

  const ownerOptions = [
    { value: '', label: 'All Owners' },
    { value: 'John Smith', label: 'John Smith' },
    { value: 'Sarah Johnson', label: 'Sarah Johnson' },
    { value: 'Michael Brown', label: 'Michael Brown' },
    { value: 'Emily Davis', label: 'Emily Davis' },
    { value: 'David Wilson', label: 'David Wilson' },
    { value: 'Lisa Anderson', label: 'Lisa Anderson' },
    { value: 'Robert Taylor', label: 'Robert Taylor' },
    { value: 'Jennifer Martinez', label: 'Jennifer Martinez' }
  ];

  const savedPresets = [
    { id: 1, name: 'Active Laptops', description: 'All active laptop assets' },
    { id: 2, name: 'Warranty Expiring', description: 'Assets with warranty expiring soon' },
    { id: 3, name: 'IT Department', description: 'All IT department assets' },
    { id: 4, name: 'Repair Queue', description: 'Assets requiring repair' }
  ];

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="w-80 bg-card border-r border-border p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-card-foreground">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear
          </Button>
        )}
      </div>
      {/* Filter Controls */}
      <div className="space-y-4">
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Select status..."
        />

        <Select
          label="Asset Type"
          options={typeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
          placeholder="Select type..."
        />

        <Select
          label="Department"
          options={departmentOptions}
          value={filters?.department}
          onChange={(value) => onFilterChange('department', value)}
          placeholder="Select department..."
        />

        <Select
          label="Owner"
          options={ownerOptions}
          value={filters?.owner}
          onChange={(value) => onFilterChange('owner', value)}
          placeholder="Select owner..."
          searchable
        />
      </div>
      {/* Save Current Filters */}
      {hasActiveFilters && (
        <div className="pt-4 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            onClick={onSavePreset}
            iconName="Save"
            iconPosition="left"
            fullWidth
          >
            Save as Preset
          </Button>
        </div>
      )}
      {/* Saved Presets */}
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-card-foreground">Saved Presets</h4>
        <div className="space-y-2">
          {savedPresets?.map((preset) => (
            <button
              key={preset?.id}
              className="w-full p-3 text-left bg-muted/50 hover:bg-muted rounded-md transition-smooth"
              onClick={() => console.log('Load preset:', preset?.name)}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-card-foreground">{preset?.name}</p>
                  <p className="text-xs text-muted-foreground">{preset?.description}</p>
                </div>
                <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
              </div>
            </button>
          ))}
        </div>
      </div>
      {/* Quick Stats */}
      <div className="pt-4 border-t border-border">
        <h4 className="text-sm font-medium text-card-foreground mb-3">Quick Stats</h4>
        <div className="grid grid-cols-2 gap-3">
          <div className="p-3 bg-success/10 rounded-md">
            <p className="text-xs text-muted-foreground">Active</p>
            <p className="text-lg font-semibold text-success">342</p>
          </div>
          <div className="p-3 bg-warning/10 rounded-md">
            <p className="text-xs text-muted-foreground">Spare</p>
            <p className="text-lg font-semibold text-warning">28</p>
          </div>
          <div className="p-3 bg-error/10 rounded-md">
            <p className="text-xs text-muted-foreground">Repair</p>
            <p className="text-lg font-semibold text-error">15</p>
          </div>
          <div className="p-3 bg-secondary/10 rounded-md">
            <p className="text-xs text-muted-foreground">Retired</p>
            <p className="text-lg font-semibold text-secondary">89</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;